import React from 'react'
import { ReactComponent as LeftArrow } from '../assets/left-arrow.svg'
import { ReactComponent as RightArrow } from '../assets/right-arrow.svg'
import { cn } from '../modules/helpers'
import useStore from '../modules/useStore'

export default function ProjectControls({ onNext, onPrev }) {
    const { atStart, atEnd } = useStore(({ currentProject, projects }) => ({
        atStart: currentProject == 0,
        atEnd: currentProject == projects.length - 1
    }))
    
    return (
        <div className="absolute bottom-0 right-0 px-4 md:px-10 my-8 md:my-10 lg:my-12 py-2 z-20 text-white flex space-x-4 pointer-events-auto">
            <div className={cn("cursor-pointer w-12 h-12 md:w-16 md:h-16", atStart && 'cursor-none pointer-events-none opacity-50')} onClick={onPrev}>
                <LeftArrow className="block w-full h-full" />
            </div>
            <div className={cn("cursor-pointer w-12 h-12 md:w-16 md:h-16", atEnd && 'cursor-none pointer-events-none opacity-50')} onClick={onNext}>
                <RightArrow className="block w-full h-full" />
            </div>
        </div>
    )
}